import { i18n_config_default } from './chunk-5FPUWZMY.mjs';
import pickBy from 'lodash/pickBy';
import sumBy from 'lodash/sumBy';

var menuCategoryAssignedMenuTypesFactoryCore = (menuTypes, menuCategoryAssignedMenuTypesIds, items, combos, assignedItems, assignedCombos, categoryId) => {
  const assignedItemsObject = pickBy(
    items,
    (_, key) => assignedItems.includes(Number(key))
  );
  const assignedCombosObject = pickBy(
    combos,
    (_, key) => assignedCombos.includes(Number(key))
  );
  return menuCategoryAssignedMenuTypesIds.map((id) => {
    var _a, _b;
    const menuType = menuTypes[id];
    const status = menuType == null ? void 0 : menuType.active;
    const itemsCount = (_a = sumBy(
      Object.values(assignedItemsObject),
      (item) => Number(
        Object.keys(item.menuTypeVersions).includes(`${id}`) && Object.values(
          item.menuTypeVersions[id].categoriesSubcategories || {}
        ).some(
          (categorySubcategory) => categorySubcategory.categoryId === categoryId
        )
      )
    )) != null ? _a : 0;
    const combosCount = (_b = sumBy(
      Object.values(assignedCombosObject),
      (combo) => Number(
        Object.keys(combo.menuTypeVersions).includes(`${id}`) && Object.values(
          combo.menuTypeVersions[id].categoriesSubcategories || {}
        ).some(
          (categorySubcategory) => categorySubcategory.categoryId === categoryId
        )
      )
    )) != null ? _b : 0;
    return {
      id,
      title: menuType == null ? void 0 : menuType.name,
      onPress: () => console.info(id),
      status,
      isStatusActive: status,
      customTag: `${i18n_config_default.t("components.menuCard.tag.itemCount", {
        count: itemsCount
      })} | ${i18n_config_default.t("components.menuCard.tag.comboCount", {
        count: combosCount
      })}`,
      count: itemsCount + combosCount
    };
  });
};

export { menuCategoryAssignedMenuTypesFactoryCore };
